import * as React from "react";
import {Switch} from "react-router";

import TopLevelRoute from "#app-shell-package/top-level-route.tsx";

const AppleRedirectPage = React.lazy(
    () => import("./apple/apple-redirect-page.tsx"),
);
const ApproveUnderAgeGatePage = React.lazy(
    () => import("./approve-under-age-gate/approve-under-age-gate-page.tsx"),
);
const CompleteSignupPage = React.lazy(
    () => import("./complete-signup/complete-signup-page.tsx"),
);
const ForgotPasswordPage = React.lazy(
    () => import("./forgot-password/forgot-password-page.tsx"),
);
const InviteSignupPage = React.lazy(
    () => import("./invite-signup/invite-signup-page.tsx"),
);
const JoinClassPage = React.lazy(() => import("./join/join-class-page.tsx"));
const LogoutPage = React.lazy(
    () => import("#shared/auth/logout/logout-page.tsx"),
);
const OAuthVerifyPage = React.lazy(
    () => import("./oauth-verify/oauth-verify-page.tsx"),
);
const ResetPasswordWidget = React.lazy(
    () => import("./reset-password/reset-password-widget.tsx"),
);
const SignupSplitter = React.lazy(
    () => import("../new_components/signup-splitter.tsx"),
);
const LoginSplitter = React.lazy(
    () => import("../new_components/login-splitter.tsx"),
);
const LoginMobile = React.lazy(
    () => import("../new_components/log-in-mobile.tsx"),
);
const TransferAuthPage = React.lazy(
    () => import("#shared/auth/transfer-auth/transfer-auth.tsx"),
);

type Props = Record<any, any>;

export default (props: Props): React.ReactElement => (
    <Switch>
        <TopLevelRoute
            path="/join/:classCode"
            exact={true}
            component={JoinClassPage}
        />
        <TopLevelRoute
            path="/join-class/:classCode"
            exact={true}
            component={JoinClassPage}
        />
        <TopLevelRoute
            path="/join-class"
            exact={true}
            component={JoinClassPage}
        />
        <TopLevelRoute path="/join" exact={true} component={JoinClassPage} />
        <TopLevelRoute
            path="/login/apple/redirect"
            exact={true}
            component={AppleRedirectPage}
        />
        <TopLevelRoute path="/login" exact={true} component={LoginSplitter} />
        <TopLevelRoute
            path="/login/mobile"
            exact={true}
            component={LoginMobile}
        />
        <TopLevelRoute
            path="/login/oauth/verify"
            exact={true}
            component={OAuthVerifyPage}
        />
        <TopLevelRoute
            path="/transfer_auth"
            exact={true}
            component={TransferAuthPage}
        />
        <TopLevelRoute path="/logout" exact={true} component={LogoutPage} />
        <TopLevelRoute
            path="/forgotpw"
            exact={true}
            component={ForgotPasswordPage}
        />
        <TopLevelRoute
            path="/pwreset"
            exact={true}
            component={ResetPasswordWidget}
        />
        <TopLevelRoute path="/signup" exact={true} component={SignupSplitter} />
        <TopLevelRoute
            path="/invitesignup"
            exact={true}
            component={InviteSignupPage}
        />
        <TopLevelRoute
            path="/completesignup"
            exact={true}
            component={CompleteSignupPage}
        />
        <TopLevelRoute
            path="/signup/under13/approve"
            exact={true}
            component={ApproveUnderAgeGatePage}
        />
    </Switch>
);
